import { Banner } from '@capsule/consumer-design-system';

import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import LinkButton from '../Elements/Button/LinkButton';

export const StyledBanner = styled(Banner)<{ isAlertBanner: boolean }>`
  ${props => props.theme.mediaQueries.smallDown} {
    justify-content: ${props => (props.isAlertBanner ? 'center' : 'space-between')};
  }
`;

export const PrecedingIconForBanner = styled(InlineSVG)`
  width: ${props => props.theme.space.s4};
  height: ${props => props.theme.space.s4};
  margin-right: ${props => props.theme.space.s2};
`;

export const StyledLinkButton = styled(LinkButton)`
  margin: 0 !important;
`;
